import React from 'react';
import PropTypes from 'prop-types';
import { dateToString } from '../../common/utils/date/Date.utils';
import { preparePriceFormat } from '../../helpers/preparePriceFormat';

function InvoiceTransactionsTableRow({ item, invoiceStatus }) {
  const { serial, amountInPence, taxAmountInPence, title, createdOn } = item || {};
  const amountAfterTax = (amountInPence || 0) + (taxAmountInPence || 0);

  return (
    <>
      <td className="fw-semibold">{serial ?? '-'}</td>
      <td>{preparePriceFormat(amountAfterTax, true) ?? '-'}</td>
      <td>{title ?? '-'}</td>
      <td>{createdOn ? dateToString(createdOn) : '-'}</td>
      <td>{invoiceStatus}</td>
    </>
  );
}

InvoiceTransactionsTableRow.propTypes = {
  item: PropTypes.object.isRequired,
  invoiceStatus: PropTypes.string,
};

InvoiceTransactionsTableRow.defaultProps = {
  invoiceStatus: 'PAID',
};

export default InvoiceTransactionsTableRow;
